import { render, staticRenderFns } from "./currencyCreateModal.vue?vue&type=template&id=18b4c2f2&"
import script from "./currencyCreateModal.vue?vue&type=script&lang=ts&"
export * from "./currencyCreateModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports